import React, { createContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'pt');

    const changeLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem('language', lang);
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const strings = {
    pt: {
        site_name: 'III Fórum de Finanças Climáticas e de Natureza',
        site_name_short: 'III Fórum',
        menu_home: 'Início',
        menu_about: 'Sobre',
        menu_agenda: 'Programação',
        menu_panelists: 'Painelistas',
        menu_day_02: 'Dia 02/06',
        menu_press: 'Imprensa',
        menu_local: 'Local',
        menu_register: 'Inscrição Convidados',
        menu_press_register: 'Inscrição Imprensa',
        btn_register: 'Inscreva-se',
        btn_send: 'Enviar',
        btn_back: 'Voltar',
        btn_more: 'Saiba mais',
        loading: 'Carregando...',
        agenda_title: 'Programação',
        agenda_subtitle: '2 e 3 de junho de 2026 | Rio de Janeiro',
        agenda_day: 'Dia 2 de junho',
        panelists_title: 'Painelistas',
        panelists_subtitle: 'Conheça os especialistas do III Fórum',
        press_title: 'Imprensa',
        press_subtitle: 'Materiais para imprensa',
        local_title: 'Local',
        local_subtitle: 'Rio de Janeiro',
        register_title: 'Inscrição',
        register_subtitle: 'Faça a sua pré-inscrição para o dia 02/06',
        register_name: 'Nome completo',
        register_email: 'E-mail',
        register_phone: 'Telefone',
        register_org: 'Organização',
        register_role: 'Cargo',
        register_age: 'Faixa etária',
        register_race: 'Raça/Cor',
        register_gender: 'Gênero',
        register_accessibility: 'Necessidade de acessibilidade',
        register_dietary: 'Restrição alimentar',
        register_participation: 'Tipo de participação',
        register_presential: 'Presencial',
        register_online: 'Online',
        register_success: 'Inscrição realizada com sucesso!',
        register_error: 'Erro ao realizar inscrição. Tente novamente.',
        register_lgpd: 'Aviso de Tratamento de Dados Pessoais: nos termos da Lei Geral de Proteção de Dados Pessoais, Lei 13.709/2018 ("LGPD") informamos que a Organização do evento "III Fórum Brasileiro de Finanças Climáticas e de Natureza" tratará os dados pessoais cadastrais relativos a pessoas físicas, representantes e/ou associados da pessoa jurídica para os fins de credenciamento para o evento. A Colab208 produtora do evento garante que o tratamento será feito em observância às melhores práticas de proteção de dados pessoais, conforme as diretrizes e princípios éticos norteadores da LGPD e garantirá o exercício dos direitos salvaguardados por aquela lei.',
        press_register_title: 'Credencial de Imprensa',
        press_register_subtitle: 'Solicite sua credencial de imprensa',
        press_register_media_type: 'Tipo de mídia',
        footer_rights: '©2026 III Fórum de Finanças Climáticas e de Natureza',
        footer_produced: 'Realização',
        event_date: '2 de junho de 2026',
        event_location: 'Rio de Janeiro',
        select_placeholder: 'Selecione...',
        required_field: 'Campo obrigatório',
        invalid_email: 'E-mail inválido',
        news_title: 'Notícias',
        events_title: 'Eventos',
        salas_title: 'Assista Aqui',
        login_title: 'Acesso',
        login_email: 'E-mail',
        login_password: 'Senha',
        login_btn: 'Entrar',
        login_error: 'Credenciais inválidas',
        gender_male: 'Masculino',
        gender_female: 'Feminino',
        gender_nonbinary: 'Não binário',
        gender_other: 'Prefiro me descrever',
        gender_no_answer: 'Prefiro não responder',
        race_black: 'Preto(a)',
        race_brown: 'Pardo(a)',
        race_white: 'Branco(a)',
        race_indigenous: 'Indígena',
        race_yellow: 'Amarelo(a)',
        race_no_answer: 'Prefiro não responder',
        age_18_24: '18 a 24 anos',
        age_25_34: '25 a 34 anos',
        age_35_44: '35 a 44 anos',
        age_45_54: '45 a 54 anos',
        age_55_64: '55 a 64 anos',
        age_65_plus: '65 anos ou mais',
        previous_editions: 'Edições Anteriores',
    },
    en: {
        site_name: '3rd Forum on Climate and Nature Finance',
        site_name_short: '3rd Forum',
        menu_home: 'Home',
        menu_about: 'About',
        menu_agenda: 'Schedule',
        menu_panelists: 'Panelists',
        menu_day_02: 'June 2nd',
        menu_press: 'Press',
        menu_local: 'Venue',
        menu_register: 'Guest Registration',
        menu_press_register: 'Press Registration',
        btn_register: 'Register',
        btn_send: 'Send',
        btn_back: 'Back',
        btn_more: 'Learn more',
        loading: 'Loading...',
        agenda_title: 'Schedule',
        agenda_subtitle: 'June 2nd - 3rd, 2026 | Rio de Janeiro',
        agenda_day: 'June 2nd',
        panelists_title: 'Panelists',
        panelists_subtitle: 'Meet the experts at the 3rd Forum',
        press_title: 'Press',
        press_subtitle: 'Press materials',
        local_title: 'Venue',
        local_subtitle: 'Rio de Janeiro',
        register_title: 'Registration',
        register_subtitle: 'Pre-register for June 2',
        register_name: 'Full name',
        register_email: 'E-mail',
        register_phone: 'Phone',
        register_org: 'Organization',
        register_role: 'Position',
        register_age: 'Age range',
        register_race: 'Race/Ethnicity',
        register_gender: 'Gender',
        register_accessibility: 'Accessibility needs',
        register_dietary: 'Dietary restrictions',
        register_participation: 'Participation type',
        register_presential: 'In-person',
        register_online: 'Online',
        register_success: 'Registration completed successfully!',
        register_error: 'Registration error. Please try again.',
        register_lgpd: 'Notice on the Processing of Personal Data: Pursuant to the Brazilian General Data Protection Law (Law No. 13,709/2018 – "LGPD"), we inform you that the organization of the event "3rd Forum on Climate and Nature Finance" will process the personal registration data of individuals, representatives and/or affiliates of legal entities for the purpose of event registration. Colab208, the event producer, ensures that data processing will be carried out in accordance with the best practices for personal data protection, following the ethical principles and guidelines of the LGPD, and will guarantee the exercise of the rights safeguarded by that law.',
        press_register_title: 'Press Credential',
        press_register_subtitle: 'Request your press credential',
        press_register_media_type: 'Media type',
        footer_rights: '©2026 3rd Forum on Climate and Nature Finance',
        footer_produced: 'Produced by',
        event_date: 'June 2nd, 2026',
        event_location: 'Rio de Janeiro',
        select_placeholder: 'Select...',
        required_field: 'Required field',
        invalid_email: 'Invalid email',
        news_title: 'News',
        events_title: 'Events',
        salas_title: 'Watch Here',
        login_title: 'Login',
        login_email: 'E-mail',
        login_password: 'Password',
        login_btn: 'Sign in',
        login_error: 'Invalid credentials',
        gender_male: 'Male',
        gender_female: 'Female',
        gender_nonbinary: 'Non-binary',
        gender_other: 'Prefer to self-describe',
        gender_no_answer: 'Prefer not to answer',
        race_black: 'Black',
        race_brown: 'Mixed',
        race_white: 'White',
        race_indigenous: 'Indigenous',
        race_yellow: 'Asian',
        race_no_answer: 'Prefer not to answer',
        age_18_24: '18 to 24',
        age_25_34: '25 to 34',
        age_35_44: '35 to 44',
        age_45_54: '45 to 54',
        age_55_64: '55 to 64',
        age_65_plus: '65 or older',
        previous_editions: 'Previous Editions',
    }
};

export default LanguageContext;
